<template>
  <div>
    <v-overlay v-if="loadingData" class="text-center">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
      <p>Cargando Actividad</p>
    </v-overlay>
    <v-card rounded="xl" class="header-selection-bar elevation-4 mb-4"
      style="top: 70px; z-index: 4; position: sticky; backdrop-filter: blur(10px); background: rgba(255, 255, 255, 0.9);">
      <v-card-text class="py-3 px-6">
        <v-row align="center" no-gutters>
          <!-- Selector de Actividad -->
          <v-col cols="12" md="4" class="pr-md-4 mb-3 mb-md-0">
            <v-autocomplete v-model="rvaDepto" :items="actividades" item-text="nm" item-value="id" label="Actividad"
              prepend-inner-icon="mdi-apps" outlined dense hide-details rounded @input="onSelectActivity"
              placeholder="Seleccione Actividad" color="primary"></v-autocomplete>
          </v-col>

          <!-- Selector de Fecha -->
          <v-col cols="12" md="4" class="pr-md-4 mb-3 mb-md-0">
            <v-menu ref="menu" v-model="menu" :close-on-content-click="true" transition="scale-transition" offset-y
              min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="date" :disabled="!rvaDepto" label="Fecha" prepend-inner-icon="mdi-calendar-clock"
                  readonly outlined dense hide-details rounded v-bind="attrs" v-on="on" color="primary"></v-text-field>
              </template>
              <v-date-picker v-model="date" no-title scrollable @change="updateSelectedDate()"
                @update:picker-date="pickerUpdate($event)" @input="menu = false" color="primary" header-color="primary">
                <v-spacer></v-spacer>
              </v-date-picker>
            </v-menu>
          </v-col>

          <!-- Botón de Acción -->
          <v-col cols="12" md="4" class="text-right">
            <v-btn v-if="rvaDepto" @click="createReseva()" color="primary" rounded large block elevation="2"
              class="text-none font-weight-bold">
              <v-icon left>mdi-plus-circle</v-icon>
              Nueva Reserva
            </v-btn>
            <div v-else class="text-subtitle-2 grey--text text-center text-md-right py-2">
              <v-icon small color="grey" class="mr-1">mdi-information-outline</v-icon>
              Seleccione actividad para continuar
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card rounded="xl" class="mt-6 elevation-3 overflow-hidden" v-show="rvaDepto">
      <v-card-text class="pa-0">
        <div class="teeSheet-wrapper">
          <div class="teeSheet">
            <!-- Cabecera de Horarios (Sticky Top) -->
            <div class="teeSheet__row teeSheet__row--header" style="position: sticky; top: 0; z-index: 6;">
              <div class="teeSheet__row-first-header">
                <v-icon small color="primary" class="mr-1">mdi-clock-outline</v-icon>
                Horarios
              </div>
              <div class="hours-container">
                <template v-for="hour in [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]">
                  <span :key="hour" :id="hour.toString().padStart(2, '0') + ':00'" class="hour-label">
                    {{ hour.toString().padStart(2, '0') }}:00
                  </span>
                </template>
                <span class="hour-label" id="00:00">00:00</span>
              </div>
            </div>

            <!-- Grid Body -->
            <div class="teeSheet-body">
              <!-- Capa de Líneas de Tiempo (Fondo) -->
              <div class="teeSheet__row teeSheet__row--lines">
                <div class="spacer-cell"></div>
                <div class="lines-container">
                  <template v-for="(time, index) in times">
                    <span :key="index" :class="[time.time, ActualTime(time.time)]" class="time-line-span"></span>
                  </template>
                </div>
              </div>

              <!-- Filas de Bahías -->
              <template v-for="(salida, index) in bahias">
                <div :key="salida.id" class="teeSheet__row bahia-row">
                  <div class="teeSheet__row-first-sticky">
                    <v-avatar color="primary lighten-4" size="24" class="mr-2">
                      <span class="primary--text font-weight-bold text-caption">{{ index + 1 }}</span>
                    </v-avatar>
                    <div class="text-truncate font-weight-bold grey--text text--darken-3"
                      style="font-size: 11px; max-width: 70px;">
                      {{ salida.nm }}
                    </div>
                  </div>
                  <ul class="teeSheet__row-bars pa-0">
                    <template v-for="(reserva, indexRes) in reservasData">
                      <li v-if="reserva.bahia == salida.id && reserva.et != 'C'" class="reservation-item" :style="{
                        'grid-row': reserva.row,
                        'grid-column': reserva.indexStart + '/' + reserva.indexEnd,
                      }" :class="reserva.Class" @click="editByFolio(reserva.fr)" :key="index + '' + indexRes">
                        <div class="reservation-content px-1">
                          <div class="player-name truncate font-weight-bold">{{ reserva.py.al }}</div>
                          <div class="reservation-time">{{ reserva.HoraInicial }} - {{ reserva.HoraFinal }}</div>
                          <div class="d-flex align-center justify-center mt-1">
                            <span class="white--text mr-1 font-weight-bold" style="font-size: 9px;">${{ reserva.tt.C
                              }}</span>
                            <v-chip x-small color="rgba(255,255,255,0.2)" dark class="font-weight-black px-1"
                              style="height: 14px; font-size: 8px;">
                              {{ reserva.fr }}
                            </v-chip>
                          </div>
                        </div>
                      </li>
                    </template>
                  </ul>
                </div>
              </template>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <v-card rounded="xl" class="mt-8 elevation-1" v-if="!rvaDepto">
      <v-card-text class="text-center py-12">
        <v-icon size="80" color="grey lighten-2" class="mb-4">mdi-calendar-search</v-icon>
        <h2 class="text-h5 font-weight-medium grey--text text--darken-2">
          Seleccione una actividad para visualizar el Tee Sheet
        </h2>
        <p class="grey--text">Optimiza la gestión de reservas de forma sencilla e intuitiva.</p>
      </v-card-text>
    </v-card>

    <v-dialog fullscreen persistent hide-overlay transition="dialog-bottom-transition" v-model="createModalToogle">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn @click="createModalToogle = false" icon dark>
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Reserva de actividades</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items> </v-toolbar-items>
        </v-toolbar>
        <v-card-text style="padding: 14px">
          <BookingActivityFormV2 ref="formAct" @changeChildDate="changeChildDate" :key="indexForm"
            :availability="reservasData" :actividades="actividades" :bahias="bahias" :ModeFolio="editModeFolio"
            :selectedFolio="selectedFolio" :rvaDepto="rvaDepto" :selectedDate="date" @onSuccess="onSuccess()" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import BookingActivityFormV2 from "./BookingActivityFormV2.vue";
import ActivityReservation from "../../../clases/ActivityReservation.js";
export default {
  name: "teeSheetTT",
  components: {
    BookingActivityFormV2,
  },
  data() {
    return {
      editModeFolio: false,
      selectedFolio: null,
      menu: false,
      date: moment().format("YYYY-MM-DD"),
      rvaDepto: null,
      indexForm: 0,
      loadingData: false,
      actividades: [],
      availableDates: [],
      bahias: [],
      times: [],
      createModalToogle: false,
      actualListener: "",
      availability: [],
    };
  },
  props: [],
  methods: {
    changeChildDate(date) {
      this.date = date
      this.updateSelectedDate()
    },
    ActualTime(time) {
      let hour = new moment();
      let dateTime = hour;
      if (hour.format("mm") != "00") {
        const remainder = 10 - (hour.minute() % 10);
        dateTime = moment(hour).add(remainder, "minutes").format("HH:mm");
      } else {
        dateTime = hour.format("mm");
      }
      if (time == dateTime) {
        return "actualTime";
      } else {
        return "";
      }
    },
    scrollToActualhour() {
      let hour = new moment().format("HH:00");

      let element = document.getElementById(hour);
      element;
      if (element) {
        try {
          this.$nextTick(() => {
            element.scrollIntoView({ block: "center" });
          });
        } catch (e) {
          console.log(e);
        }
      } else {
        this.scrollToActualhour();
      }
    },
    openForm(bahia) {
      this.createReseva();
    },
    createReseva() {
      this.selectedFolio = null;
      this.editModeFolio = false;
      this.indexForm++;
      this.createModalToogle = true;
    },
    editByFolio(folio) {
      this.selectedFolio = folio;
      this.editModeFolio = true;
      this.indexForm++;
      this.createModalToogle = true;
    },
    buildTimesData() {
      let initTime = new moment("06:00", "HH:mm");
      let endTime = new moment("23:00", "HH:mm");
      //endTime.add(10, "minutes")
      let auxDate = initTime;
      this.times = [];
      this.times.push({ time: "05:50" });
      var i;
      for (i = 0; auxDate.format("HH:mm") <= endTime.format("HH:mm"); i++) {
        this.times.push({
          time: auxDate.format("HH:mm"),
        });
        auxDate = auxDate.add(10, "minutes");
      }
      this.times.push({ time: "23:10" });
      this.times.push({ time: "23:20" });
      this.times.push({ time: "23:30" });
      this.times.push({ time: "23:40" });
      this.times.push({ time: "23:50" });
      this.times.push({ time: "00:00" });
    },
    onSuccess() {
      this.createModalToogle = false;
    },
    onSelectActivity() {
      this.getBahias();
      this.getReservas();
      this.scrollToActualhour();
    },
    async getActividades() {
      let actividades = [];
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "ACT/Actividades"
        );
      if (snapshot.val()) {
        let docs = Object.entries(snapshot.val());
        docs.forEach((element) => {
          actividades.push({ id: element[0], ...element[1] });
        });
        this.actividades = actividades;

      } else {
        this.actividades = [];
      }
    },
    updateSelectedDate() {
      this.loadingData = true;
      //this.selectDate(this.date);
      this.loadingData = false;
      this.getReservas();
    },
    pickerUpdate(val) {
      let totalDay = moment(val, "YYYY-MM").daysInMonth();
      let weekDay = [];

      let disable_dates = [];
      let open_dates = [];

      /*this.daysRules.forEach((element) => {
        if (element.data === false) {
          disable_dates.push(element.date, "YYYY-MM-DD");
        } else {
          open_dates.push(element.date);
        }
      });*/

      let availableDates = [];

      let monthNow = moment().format("M");
      let monthSelected = moment(val).format("M");
      let day;

      if (monthNow == monthSelected) day = moment().format("D");
      else day = 1;

      for (let i = day; i <= totalDay; i++) {
        let date = moment()
          .month(val.split("-")[1] - 1)
          .date(i)
          .format("YYYY-MM-DD");
        if (
          !weekDay.includes(moment(date).day()) &&
          !disable_dates.includes(date)
        ) {
          if (date >= moment().format("YYYY-MM-DD")) {
            availableDates.push(date);
          }
        }

        if (weekDay.includes(moment(date).day()) && open_dates.includes(date)) {
          if (date >= moment().format("YYYY-MM-DD")) {
            availableDates.push(date);
          }
        }
      }
      this.availableDates = availableDates;
      //this.allowedDates();
    },
    async getBahias() {
      let bahias = [];
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "ACT/Bahias"
        );
      if (snapshot.val()) {
        let docs = Object.entries(snapshot.val());
        docs.forEach((element) => {
          if (element[1].ia == this.rvaDepto) {
            bahias.push({ id: element[0], ...element[1] });
          }
        });
      }
      bahias = this.$_.orderBy(bahias, "od", "asc");
      this.bahias = bahias;
    },
    scrollOnDragg() {
      const ele = this.$el.querySelector(".teeSheet");
      ele.style.cursor = "grab";

      let pos = { top: 0, left: 0, x: 0, y: 0 };

      const mouseDownHandler = function (e) {
        ele.style.cursor = "grabbing";
        ele.style.userSelect = "none";

        pos = {
          left: ele.scrollLeft,
          top: ele.scrollTop,
          // Get the current mouse position
          x: e.clientX,
          y: e.clientY,
        };

        document.addEventListener("mousemove", mouseMoveHandler);
        document.addEventListener("mouseup", mouseUpHandler);
      };

      const mouseMoveHandler = function (e) {
        // How far the mouse has been moved
        const dx = e.clientX - pos.x;
        const dy = e.clientY - pos.y;

        // Scroll the element
        ele.scrollTop = pos.top - dy;
        ele.scrollLeft = pos.left - dx;
      };

      const mouseUpHandler = function () {
        ele.style.cursor = "grab";
        ele.style.removeProperty("user-select");

        document.removeEventListener("mousemove", mouseMoveHandler);
        document.removeEventListener("mouseup", mouseUpHandler);
      };

      // Attach the handler
      ele.addEventListener("mousedown", mouseDownHandler);
    },
    async getReservas() {
      let date = this.date;
      this.killListener(this.actualListener);
      let listener = "ACT/Availability/" + this.rvaDepto + "/" + date;
      this.$store.getters.getFirebaseApp.database.queryBuilderListener(
        listener,
        null,
        (snapshot) => {
          try {
            if (snapshot.exists()) {
              this.availability = [];

              let arrayReservas = snapshot.val();

              this.availability =
                ActivityReservation.parseAvailability(arrayReservas);
              console.log(this.$refs)
              if (this.$refs.formAct) {
                console.log(this.$refs.formAct)
                this.$refs.formAct.setReloadTimes()
              }
              //this.$refs.formAct.processAvailables()
            } else {
              this.availability = [];
            }
          } catch (e) {
            console.log(e);
          }
        }
      );
      this.actualListener = "ACT/Availability/" + this.rvaDepto + "/" + date;
    },
    killListener(listener) {
      if (listener != "") {
        const ref = this.$store.getters.getFirebaseApp.database.ref(listener);
        this.$store.getters.getFirebaseApp.database.off(ref);
      }
    },
    roundTimes(time) {
      let dateTime = time;
      let hour = "";
      const start = moment(time, "HH:mm");
      if (start.format("mm") != "00") {
        const remainder = 10 - (start.minute() % 10);
        dateTime = moment(start).add(remainder, "minutes").format("HH:mm");
      } else {
        dateTime = time;
      }

      return dateTime;
    },
  },
  computed: {
    ...mapGetters(["getFirebaseApp"]),
    showOneRow() {
      //if (this.$store.getters.getFirebaseApp.tenant == "BOKA" &&) {
      return true;
      //} else {
      //return false;
      //}
    },
    reservasData() {
      let reservas = [];
      let bahiaGrouper = {};
      this.availability.forEach((res) => {
        if (res.et != "C") {
          if (!bahiaGrouper[res.bahia]) {
            bahiaGrouper[res.bahia] = [];
          }
          if (!this.showOneRow) {
            bahiaGrouper[res.bahia].push(res);
          } else {
            let exist = this.$pgsHelper.getById(
              bahiaGrouper[res.bahia],
              "fr",
              res.fr
            );
            if (!exist) {
              bahiaGrouper[res.bahia].push(res);
            }
          }
        }
      });
      let grouper = Object.entries(bahiaGrouper);
      grouper.forEach((bahia) => {
        let reservasBahia = [];
        bahia[1].forEach((res) => {
          if (res.et == "P") {
            res.Class = "Pagado";
          } else {
            res.Class = "Reservado";
          }
          res.row = 1;
          res.indexStart = this.$_.findIndex(this.times, [
            "time",
            moment(this.roundTimes(res.HoraInicial), "HH:mm").format("HH:mm"),
          ]);
          res.indexEnd = this.$_.findIndex(this.times, [
            "time",
            moment(this.roundTimes(res.HoraFinal), "HH:mm:ss").format("HH:mm"),
          ]);
          /*verificar cual es el row a asignar para la reserva*/
          if (reservasBahia.length == 0) {
            res.row = 1;
          } else {
            let reservasEnRango = [];
            reservasBahia.forEach((reservation) => {
              if (
                reservation.indexStart == res.indexStart ||
                reservation.indexEnd == res.indexEnd
              ) {
                reservasEnRango.push(reservation);
              }
              if (
                reservation.indexStart < res.indexStart &&
                reservation.indexEnd > res.indexStart
              ) {
                reservasEnRango.push(reservation);
              }
              if (
                reservation.indexStart < res.indexEnd &&
                reservation.indexEnd > res.indexEnd
              ) {
                reservasEnRango.push(reservation);
              }
            });
            if (reservasEnRango.length == 0) {
              res.row = 1;
            } else {
              reservasEnRango = this.$_.orderBy(reservasEnRango, "row", "asc");
              let ultimoRow = reservasEnRango[reservasEnRango.length - 1].row;
              res.row = Number(ultimoRow) + 1;
            }
          }
          reservasBahia.push(res);
        });

        reservas = [...reservas, ...reservasBahia];
      });

      return reservas;
    },
  },
  async mounted() {
    this.getActividades();
    this.buildTimesData();
    this.scrollOnDragg();
    this.scrollToActualhour();
  },
  async beforeMount() { },
  created() { },
  watch: {},
};
</script>
<style>
.actualTime {
  background-color: rgba(33, 186, 69, 0.1) !important;
  border-right: 2px solid #21BA45 !important;
  position: relative;
  z-index: 2;
}

.actualTime::after {
  content: "AHORA";
  position: absolute;
  top: -24px;
  right: -20px;
  background: #21BA45;
  color: white;
  font-size: 8px;
  padding: 2px 5px;
  border-radius: 4px;
  font-weight: 800;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.Pagado {
  background: linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%) !important;
  box-shadow: 0 4px 10px rgba(76, 175, 80, 0.2);
}

.Reservado {
  background: linear-gradient(135deg, #2196F3 0%, #1565C0 100%) !important;
  box-shadow: 0 4px 10px rgba(33, 150, 243, 0.2);
}

.teeSheet-wrapper {
  background: #f8fafc;
  border-radius: 0 0 16px 16px;
  border: 1px solid #e2e8f0;
}

.teeSheet {
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: auto;
  max-height: 72vh;
  background: white;
}

.teeSheet__row {
  display: grid;
  grid-template-columns: 100px 1fr;
  min-width: fit-content;
}

.teeSheet__row--header {
  background: #ffffff !important;
  border-bottom: 2px solid #cbd5e1;
}

.teeSheet__row-first-header {
  width: 100px;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 10px;
  text-transform: uppercase;
  color: #475569;
  border-right: 2px solid #cbd5e1;
  position: sticky;
  left: 0;
  z-index: 20;
}

.hours-container {
  display: grid;
  grid-template-columns: repeat(18, 252px) 252px;
  background: #ffffff;
}

.hour-label {
  width: 252px;
  text-align: center;
  padding: 14px 0;
  font-weight: 800;
  font-size: 13px;
  color: #1e293b;
  border-right: 1px solid #e2e8f0;
  background: #fff;
}

.teeSheet-body {
  position: relative;
}

.teeSheet__row--lines {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 1;
}

.lines-container {
  display: grid;
  grid-template-columns: repeat(120, 42px);
  height: 100%;
}

.time-line-span {
  border-right: 1px solid rgba(226, 232, 240, 0.5);
  height: 100%;
}

.bahia-row {
  background: #ffffff;
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.2s;
}

.bahia-row:hover {
  background: #fcfdfe;
}

.teeSheet__row-first-sticky {
  width: 100px;
  min-height: 80px;
  position: sticky;
  left: 0;
  z-index: 6;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-right: 2px solid #e2e8f0;
  box-shadow: 4px 0 8px rgba(0, 0, 0, 0.02);
  padding: 10px;
}

.bahia-row:hover .teeSheet__row-first-sticky {
  background: #f8fafc;
}

.teeSheet__row-bars {
  list-style: none;
  display: grid;
  grid-template-columns: repeat(120, 42px);
  grid-auto-rows: 42px;
  padding: 12px 0 !important;
  z-index: 2;
}

.reservation-item {
  margin: 3px;
  border-radius: 6px;
  cursor: pointer;
  display: flex !important;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  min-height: 80px;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
}

.reservation-item:hover {
  transform: translateY(-3px) scale(1.01);
  filter: brightness(1.1);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2) !important;
  z-index: 15 !important;
}

.reservation-content {
  width: 100%;
  text-align: center;
  color: white;
}

.player-name {
  font-size: 11px;
  letter-spacing: -0.2px;
  font-weight: 700;
}

.reservation-time {
  font-size: 9px;
  opacity: 0.85;
  font-weight: 500;
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.stripes {
  background-image: repeating-linear-gradient(45deg,
      transparent,
      transparent 5px,
      rgba(255, 255, 255, 0.1) 5px,
      rgba(255, 255, 255, 0.1) 12px);
}

.teeSheet__row-bars li:before,
.teeSheet__row-bars li:after {
  content: "";
  height: 100%;
  top: 0;
  z-index: 4;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.1);
}

.spacer-cell {
  width: 100px;
}
</style>
